module.exports = __webpack_public_path__ + "images/star_small_filled965043fb62a5aef9b95c49d692693b82.svg";